import { DefaultButton, Icon, SearchBox } from '@fluentui/react';
import OptionPicker from '../../../../common/views/OptionPicker';
import { Utils } from '../../../../common/views/Utils';
import { OrderStatus } from '../../../models/OrderModel';
import { OrderHeaderProps } from './OrderHeaderView';

export default function OrderHeaderCompactView({
    filter, statuses, setStatuses, onValueChange, onGetList, setShowAdd, onShowFilter
}: OrderHeaderProps) {
    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);
    const width12 = Utils.getColumnWidth(12);

    const onStatusChange = (status: OrderStatus) => {
        filter.status = status;
        filter.pageNumber = 1;
        onGetList(false, false);
    }

    const createMenuItems = () => {
        let items = [
            {
                key: 'add',
                onClick: () => setShowAdd(true),
                iconProps: { iconName: 'Add' },
                text: 'Add'
            },
            {
                key: 'filter',
                onClick: onShowFilter,
                iconProps: { iconName: 'Filter' },
                text: 'Filter'
            },
            {
                key: 'refresh',
                onClick: () => onGetList(true, false),
                iconProps: { iconName: 'Refresh' },
                text: 'Refresh'
            }
        ];

        return items;
    }

    const menuView = () => {
        return <>
            <DefaultButton
                menuProps={{
                    shouldFocusOnMount: true,
                    items: createMenuItems()
                }}
                className="context-menu-text"
                styles={{
                    root: { height: 40, minWidth: 40, width: 40 },
                    menuIcon: { display: "none !important" }
                }}
                style={{ backgroundColor: "white", height: 32, fontSize: "large", paddingLeft: 8 }}>
                <Icon iconName="BulletedListTextMirrored" />
            </DefaultButton>
        </>;
    }

    const searchInput = () => {
        return <>
            <SearchBox
                autoFocus={false}
                value={filter.search}
                placeholder="Search"
                onChange={(_, newValue) => onValueChange("search", newValue || "")}
                onSearch={(value: string) => onGetList(true, false)}
                className="searchbox"
            />
        </>
    }

    return <div className="blue-background pt-10 ph-10">
        <div className="ms-Grid-row" >
            <div className={width10 + " left"}>{searchInput()}</div>
            <div className={width2 + " right"}>{menuView()}</div>
        </div>

        <div className="ms-Grid-row pt-10 center" style={{ display: "inline-block", fontSize: 12 }}>
            <div className={width12}>
                <OptionPicker
                    options={statuses}
                    setOptions={setStatuses}
                    onChange={onStatusChange}
                    padding={3}
                />
            </div>
        </div>
    </div>
}